import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {useFetch} from "../../../../../../services/useFetch";
import {API_CONTRACT_NON_EMPLOYEE} from "../../../../../../services/apiContractNonEmployee";
import {setContractDetail, setOptions} from "../../../../../../reducers/contractReducer";
import {FORM_CREATE_CONTRACT_NON_EMPLOYEE} from "../../../../../../constants/constant-management-contract";
import {FormContractNonEmployeeContainer} from "../../../../form-contract/FormContractNonEmployeeContainer";
import {constructOptionsSelect, convertArrayToObject, formatDateMoment} from "../../../../../../utils/utils";
import {Alert} from "../../../../../../components/commons/alert";

export const RenewContractContainer = () => {
    const [searchParams] = useSearchParams();
    const contractId = searchParams.get('contractId')
    const employeeId = searchParams.get('employeeId')
    const dispatch = useDispatch()
    const [errorForm, setErrorForm] = useState({})
    const {contractDetail} = useSelector(state => state.contractReducer)
    const {fetching: getContractDetailApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.DETAIL_CONTRACT)
    const {fetching: getCompanyListApi} = useFetch({...API_CONTRACT_NON_EMPLOYEE.LIST_COMPANY, initPathVariable: employeeId})
    const {fetching: getConstantApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.CONSTANT)
    const {fetching: renewContractApi} = useFetch(API_CONTRACT_NON_EMPLOYEE.RENEW_CONTRACT)

    useEffect(() => {
        Promise.all([getContractDetailApi({}, contractId), getConstantApi(), getCompanyListApi()])
            .then(res => {
                let ptkp_status = constructOptionsSelect(res[1].data.ptkp_status)
                let company = constructOptionsSelect(res[2].data, 'name', 'company_id')
                dispatch(setContractDetail({nip: res[0].data.nip, ptkp_status: ptkp_status[0]}))
                dispatch(setOptions({ptkp_status, company}))
            })
    }, []);

    const onSubmitForm = () => {
        let requestBody = {
            ...contractDetail,
            company_id: contractDetail.company.value,
            job_title_id: contractDetail.job_title.value,
            grade_id: contractDetail.grade.value,
            type: contractDetail.type,
            ptkp_status: contractDetail.ptkp_status.value,
            start_date: formatDateMoment(contractDetail.start_date, 'YYYY-MM-DD'),
            end_date: formatDateMoment(contractDetail.end_date, 'YYYY-MM-DD'),
        }

        renewContractApi(requestBody, contractId)
            .then(res => {
                Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Perubahan Contract berhasil!',
                })
                window.location.href = `/non-employee-worker/non-employee-contract-detail?contractId=${contractId}`
            })
            .catch(err => {
                console.log(err)
                if (err.code === '422') {
                    setErrorForm(convertArrayToObject(err.data))
                }
            })
    }

    let props = {
        errorForm,
        onSubmitForm,
        form: FORM_CREATE_CONTRACT_NON_EMPLOYEE,
        activity: 'renew'
    }

    return (
        <FormContractNonEmployeeContainer {...props}/>
    )
}
